export default function Configure($stateProvider) {
	$stateProvider.state('prospects', {
		parent: 'common',
		url: '/prospects',
		//abstract: true,
		views: {
			common: {
				template: '<ui-view></ui-view>'
			}
		},
		ncyBreadcrumb: {
			//skip: true
			label: '{{ "LAYOUT.NAVIGATION.GESTION_COMMERCIALE" | translate }}'
		}
	});

	$stateProvider.state('prospects.list', {
		url: '/list',
		template: '<prospects></prospects>',
		rights: { domain: 'prospects', right: 'read' },
		ncyBreadcrumb: {
			label: '{{ "PROSPECTS.BREADCRUMBS.PROSPECTS_LIST" | translate}}'
		},
		navigation: {
			menu: 'gestion_commerciale_commercial',
			translate: 'PROSPECTS.BREADCRUMBS.PROSPECTS_LIST',
			order: 4,
			navigationCls: 'menu-item-separator'
		},
		search: 'PROSPECTS.BREADCRUMBS.PROSPECTS_LIST'
	});

	$stateProvider.state('prospects.list.detail', {
		url: '/{id}',
		template: '<prospect-detail></prospect-detail>',
		rights: { domain: 'prospects', right: 'read' },
		ncyBreadcrumb: {
			parent: 'prospects.list',
			label: '{{ "PROSPECTS.BREADCRUMBS.PROSPECT_DETAIL" | translate }}'
		}
	});

	$stateProvider.state('prospects.new', {
		url: '/new',
		template: '<prospect-form></prospect-form>',
		rights: { domain: 'prospects', right: 'create' },
		params: {
			fromOffre: false,
			contactId: null,
			idSociete: null
		},
		ncyBreadcrumb: {
			parent: 'prospects.list',
			label: '{{ "PROSPECTS.BREADCRUMBS.PROSPECT_NEW" | translate}}'
		},
		search: 'PROSPECTS.BREADCRUMBS.PROSPECT_NEW'
	});

	$stateProvider.state('prospects.edit', {
		url: '/{id}/edit',
		template: '<prospect-form></prospect-form>',
		rights: { domain: 'prospects', right: 'update' },
		params: {
			fromOffre: false,
			contactId: null
		},
		ncyBreadcrumb: {
			parent: 'prospects.list',
			label: '{{ "PROSPECTS.BREADCRUMBS.PROSPECT_EDIT" | translate }}'
		}
	});
}

Configure.$inject = ['$stateProvider'];
